module.exports = __webpack_public_path__ + "static/media/share-of-debt.30c19de7.png";